// extracted by extract-css-chunks-webpack-plugin
module.exports = {"split-flap":"split-flap___19uue","comma":"comma___235Li","period":"period___2uSi7","card":"card___jwX_q"};